<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Patologica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiPatologica.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiPatologica.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataAnamnesiPatologica.id" @click="onSaveAnamnesiPatologica"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiPatologica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiPatologica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiPatologica: "/rsaschedarelazionesanitariaanamnesipatologica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiPatologica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiPatologica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiPatologicaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiPatologicaError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPatologicaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiPatologica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPatologicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiPatologica = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveAnamnesiPatologica() {
            let me = this;
            me.jsonDataAnamnesiPatologica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiPatologica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiPatologica, me.jsonDataAnamnesiPatologica, me.saveSchedaRelazioneSanitariaAnamnesiPatologicaSuccessResponse, me.saveSchedaRelazioneSanitariaAnamnesiPatologicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiPatologicaSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Anamnesi patologica salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaAnamnesiPatologicaErrorResponse() {
            console.error("Errore nel salvataggio anamnesi patologica:");
        },
    },
};
</script>
